import type { CarouselModel } from "src/models/carousel";
import { DoctorListModel } from "src/models/doctorList";
import type { FAQModel } from "src/models/faq";
import type { PartnerModel } from "src/models/partner";
import { SecretIndent } from "src/models/paymentIndent";
import type { ServiceModel } from "src/models/service";
import { SlotData } from "src/models/slot";
import { SubServiceModel } from "src/models/subService";
import type { TestimonialModel } from "src/models/testimonial";
import { UnregisteredLogModel } from "src/models/unregisteredlog";
import { Drug } from "src/sections/service/special-service/drug-search";
import { ApiService } from "src/services/apiService";
import { ConsultationResponse } from "src/models/consultation";

const apiService = new ApiService();

export const getBanners = async (status:boolean = false, isActive:boolean = true, includeExpired:boolean) => apiService.get<CarouselModel[]>(`Home/GetCarousel${status
        ? `?isActive=${isActive}&includeExpired=${includeExpired}`
        : `?includeExpired=${includeExpired}`
    }`
);

export const getServices = async () => apiService.get<ServiceModel[]>('Home/GetServices?isActive=true');

export const getTestimonials = async (status:boolean = false, isActive:boolean = true) => apiService.get<TestimonialModel[]>(`Home/GetTestimonial${status ? `?isActive=${isActive}`: ''}`);

export const getPartners = async () => apiService.get<PartnerModel[]>('Home/GetPartner?isActive=true&includeExpired=true');

export const getFaqs = async (status:boolean = false, isActive:boolean = true) => await apiService.get<FAQModel[]>(`Home/GetFaq${status ? `?isActive=${isActive}`: ''}`);

export const getAllHomeData = async () => {
    try {
        const [banners, services, testimonials, partners, faqs] = await Promise.all([
            getBanners(true, true,true),
            getServices(),
            getTestimonials(true, true),
            getPartners(),
            getFaqs(true, true)
        ]);
        return { banners, services, testimonials, partners, faqs };
    } catch (error) {
        console.debug('Failed to fetch home data:', error);
        throw error;
    }
};

export const getServiceById = async (id: string) => apiService.get<ServiceModel>(`Home/GetServicesById?id=${id}`);

export const getsubServicesbyServiceId = async (id: string) => apiService.get<SubServiceModel[]>(`Home/GetSubServices?id=${id}`);

export const getPaymentIndent = async (amount: number) => apiService.post<SecretIndent>(`Payment/CreateIntent?amount=${amount}`,{});

export const getDrugs = async () => apiService.get<Drug[]>(`Home/GetDrugs`);

export const createConsultation = async (data:any) => apiService.post<ConsultationResponse>(`Home/CreateConsultant`,data);

export const getAvailableDoctors = async(start:number,end:number) => apiService.get<DoctorListModel[]>(`Home/GetAvailableDoctors?starttime=${start}&endtime=${end}`);

export const getDoctorSlot = async(id: string,start:number,end:number) => apiService.get<SlotData>(`Home/GetDoctorAvailability?id=${id}&starttime=${start}&endtime=${end}`);
export const getUnregisteredComplaint = async () => apiService.get<UnregisteredLogModel[]>(`Home/GetPatientComplaint`);

export const createPatientLog  = async (data:any) => apiService.post(`Home/CreatePatientLog`,data);

export const checkEmailExists = async (email: string) => apiService.get<boolean>(`Home/CheckEmailExists?email=${encodeURIComponent(email)}`);
